// removed by extract-text-webpack-plugin
module.exports = {"propertiesContainer":"_1CWQjogf61xkldUGJBAJI-","properties":"_12xYZSm9_CL9M0uiicZJeb","showMoreButton":"_1rPQh5WeDyHA1XfvVC56s4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyProperties/CompanyProperties.scss
// module id = 1576
// module chunks = 0